// extracted by mini-css-extract-plugin
export default {"placeholder":"ImpactPostsListRecordLoader_placeholder__XERSP"};